import PropTypes from "prop-types";

const ResearchPropType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  totalAmount: PropTypes.number.isRequired,
  totalAmountNotMatch: PropTypes.number.isRequired,
});

const CatchAreaPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  coordinates: PropTypes.arrayOf(PropTypes.number),
  region: PropTypes.string.isRequired,
  sources: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    dataMode: PropTypes.string.isRequired,
    researchSources: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })).isRequired,
  })).isRequired,
  researches: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    dataMode: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
    notMatch: PropTypes.number.isRequired,
  })).isRequired,
});

const PoolPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  coordinates: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.arrayOf(
      PropTypes.number.isRequired
  )).isRequired).isRequired,
  catchAreas: PropTypes.arrayOf(CatchAreaPropType).isRequired,
});

const PeriodDataPropType = PropTypes.shape({
  periodId: PropTypes.string.isRequired,
  pageTitle: PropTypes.string.isRequired,
  archiveTitle: PropTypes.string.isRequired,
});


export {
  CatchAreaPropType,
  PeriodDataPropType,
  PoolPropType,
  ResearchPropType,
};
